import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-415735b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "area-table" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "table-block" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
          default: _withCtx(() => [
            _createVNode(_component_Table, {
              columns: _ctx.columns,
              bordered: "",
              "data-source": _ctx.areaTableData,
              rowKey: "key",
              pagination: _ctx.pagination
            }, {
              street: _withCtx(({ text: street }) => [
                _createTextVNode(_toDisplayString(street), 1)
              ]),
              op: _withCtx(({ record }) => [
                _createElementVNode("div", {
                  class: "btn",
                  onClick: ($event: any) => (_ctx.handleDetail(record))
                }, "详情", 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "pagination"])
          ]),
          _: 1
        }, 8, ["locale"])
      ])
    ])
  ]))
}